/**
 * Phase 8 AI/Analytics API client (additive).
 */
import { apiClient } from "./api";

export const aiAPI = {
  search: (payload) => apiClient.post("/platform/ai/search", payload).then((r) => r.data),
  suggest: (q, limit = 8) => apiClient.get("/platform/ai/suggest", { params: { q, limit } }).then((r) => r.data),
  logEvent: (payload) => apiClient.post("/platform/ai/events", payload).then((r) => r.data),
  similar: (listing_id, limit = 8) => apiClient.get(`/platform/ai/recommendations/similar/${listing_id}`, { params: { limit } }).then((r) => r.data),
  related: (listing_id, limit = 8) => apiClient.get(`/platform/ai/recommendations/related/${listing_id}`, { params: { limit } }).then((r) => r.data),
  bundle: (listing_id) => apiClient.get(`/platform/ai/recommendations/bundle/${listing_id}`).then((r) => r.data),
  businesses: (params = {}) => apiClient.get("/platform/ai/recommendations/businesses", { params }).then((r) => r.data),
  estimatePrice: (payload) => apiClient.post("/platform/ai/pricing/estimate", payload).then((r) => r.data),
  assistantAsk: (payload) => apiClient.post("/platform/ai/assistant/ask", payload).then((r) => r.data),
  assistantSession: (sid) => apiClient.get(`/platform/ai/assistant/session/${sid}`).then((r) => r.data),
  fraudEnhancedScan: () => apiClient.post("/platform/ai/fraud/scan/enhanced").then((r) => r.data),
};

export const analyticsAPI = {
  overview: () => apiClient.get("/platform/analytics/overview").then((r) => r.data),
  growth: (days = 30) => apiClient.get("/platform/analytics/growth", { params: { days } }).then((r) => r.data),
  topCategories: (limit = 8) => apiClient.get("/platform/analytics/top-categories", { params: { limit } }).then((r) => r.data),
  topCities: (limit = 8) => apiClient.get("/platform/analytics/top-cities", { params: { limit } }).then((r) => r.data),
  mostViewed: (limit = 10) => apiClient.get("/platform/analytics/most-viewed", { params: { limit } }).then((r) => r.data),
  conversion: (days = 30) => apiClient.get("/platform/analytics/conversion", { params: { days } }).then((r) => r.data),
  business: (bid) => apiClient.get(`/platform/analytics/business/${bid}`).then((r) => r.data),
  me: () => apiClient.get("/platform/analytics/user/me").then((r) => r.data),
};
